var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ajax-loader{opacity:.5;border-radius:5px;background:#fff url(" + escape(require("../assets/loader-eclipse.gif")) + ") no-repeat 50%;z-index:999999}.ajax-loader,.ajax-loader:after{position:fixed;width:100%;height:100%;left:0;top:0}.ajax-loader:after{content:\"\";display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ba5b634e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Loader.vue
// module id = 1432
// module chunks = 0